import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['message', 'confirm']

  connect() {
    this.open = this.open.bind(this)
    this.hidden = this.hidden.bind(this)
    window.addEventListener('confirm-modal:open', this.open)
    this.element.addEventListener('modal:hidden', this.hidden)
  }

  disconnect() {
    window.removeEventListener('confirm-modal:open', this.open)
    this.element.removeEventListener('modal:hidden', this.hidden)
  }

  open(event) {
    this.callback = event.detail.callback
    this.messageTarget.textContent = event.detail.message
    this.element.dispatchEvent(new CustomEvent('modal:show'))
    this.confirmTarget.focus({ preventScroll: true })
  }

  confirm(event) {
    event.preventDefault()

    const cb = this.callback
    this.callback = null
    cb?.()
    this.element.dispatchEvent(new CustomEvent('modal:hide'))
  }

  // ModalComponent's focus trap keeps Tab inside and returns focus to the opener
  hidden() {
    this.callback = null
  }
}
